var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isUserLogged)?_c('div',[_c('vv-section-title',{staticClass:"Title"},[_vm._v(_vm._s(_vm.welcomeMessage))])],1):_c('AccountChecker'),_c('vv-collapsable',{attrs:{"title":'Mon panier',"name":'panier'}},[_c('CartSummary')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }